import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressViewComponent } from './address-view/address-view.component';
import { SharedCoreModule } from '../shared-core/shared-core.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CheckoutComponent } from './checkout.component';
import { SharedModule } from '../shared/shared.module';
import { CartBundleItemsComponent } from '../checkout/cart-bundle-items/cart-bundle-items.component';
import { CartItemsComponent } from '../checkout/cart-items/cart-items.component';
import { PaymentComponent } from './payment/payment.component';
import { SummaryComponent } from './summary/summary.component';
import { GiftCardsComponent } from './gift-cards/gift-cards.component';
import { AccountModule } from '../account/account.module';
import { AddressPickComponent } from './address-pick/address-pick.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    GiftCardsComponent,
    AddressViewComponent,
    CheckoutComponent,
    CartBundleItemsComponent,
    CartItemsComponent,
    PaymentComponent,
    SummaryComponent,
    GiftCardsComponent,
    AddressPickComponent
  ],
  imports: [
    AccountModule,
    CommonModule,
    SharedCoreModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    NgxPayPalModule,
    AngularSvgIconModule,
  ]
})
export class CheckoutModule { }
